import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Box, Button, Flex, Indicator, Loader, Text, Title } from "@mantine/core";
import useStyles from "./style";
import { getSingleNote } from "../../services/note";
import SignatureRequestModal from "../SignatureModal";
import { updateChangeSignature } from "../../services/signature";
import { acceptContractorRequest, declineContractorRequest, getNotifications, getNotificationsCount } from "../../services/notification";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const NewNotificationCardComp = ({
  notification,
  handleReadNotification,
  isLoading,
  isReadAll,
  profile,
  onClickNotification,
  onOpenSignatureModal,
  setPopoverOpened,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  // const [signatureModalOpened, setSignatureModalOpened] = useState(false);
  const { signature } = useSelector((state) => state?.signature);

  const handleClick = async () => {
    if (notification?.module === "document") {
      const id =
        notification?.facility?.id ||
        notification?.staff?.id ||
        notification?.client?.id;
      if (id) {
        navigate(`/home/facility/${id}/view`, {
          state: { notificationDoc: notification },
        });
      }
    }

    if (notification?.module === "billing_authorization") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.billing
      ) {
        navigate("/home/billing-claim-form", {
          state: {
            manage: "client",
          },
        });
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Billing.",
          dangerMode: true,
        });
      }
    }

    if (notification?.module === "Invoice") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.invoice
      ) {
        navigate("/home/invoices");
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Invoice.",
          dangerMode: true,
        });
      }
    }

    if (notification && notification?.module === "document") {
      if (notification?.facility?.id) {
        navigate(`/home/facility/${notification?.facility?.id}/view`, {
          state: {
            notificationDoc: notification,
          },
        });
      } else if (notification?.staff) {
        navigate(`/home/staff/${notification?.staff?.id}/view`, {
          state: {
            notificationDoc: notification,
          },
        });
      } else if (notification?.client) {
        navigate(`/home/client`, {
          state: {
            notificationDoc: notification,
            //  client: notification?.client,
          },
        });
      }
    }
    if (notification && notification?.module === "patient") {
      if (signature === null || !signature) {
        swal({
          title: "Signature Required",
          text: "Please add a signature from setting page to continue",
          dangerMode: true,
          icon: "warning",
          buttons: {
            cancel: {
              text: "Cancel",
              visible: true,
              className: classes.cancelBtn,
            },
            confirm: {
              text: "Setup Signature",
              value: true,
              className: classes.setupBtn,
            },
          },
        }).then((value) => {
          if (value) {
            navigate("/home/settings", {
              state: { selectedTab: "my-signature" },
            });
          }
        });
      } else {
        navigate(`/home/client`, {
          state: {
            client: notification,
          },
        });
      }
    }

    if (notification && notification?.module === "signature") {
      if (notification?.userType === "staff") {
        navigate(`/home/settings`, { state: { selectedTab: "my-signature" } });
      } else {
        // setSignatureModalOpened(true);
        onOpenSignatureModal(notification);
      }
    }

    if (notification && notification?.module === "Care Plan") {
      navigate(`/home/client`, {
        state: {
          planDoc: notification,
          //  client: notification?.client,
        },
      });
    }

    if (notification && notification?.module === "Medication") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.medication
      ) {
        navigate(`/home/medication`, {
          state: {
            medication: notification,
          },
        });
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Medication.",
          dangerMode: true,
        });
      }
    }

    if (notification && notification?.module === "Scheduler") {
      navigate("/home/scheduler", {
        state: {
          focusShiftId: notification?.moduleId,
        },
      });
    }

    if (!notification?.readedUsers?.includes(profile?.user?.id)) {
      handleReadNotification(notification?._id);
    }
    if (notification?.module === "Note") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.note
      ) {
        onClickNotification(notification?.moduleId);
        await getSingleNote(notification?.moduleId);
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Note.",
          dangerMode: true,
        });
      }
    }
    if (notification?.module === "SkaiToken") {
      navigate("/home/settings", { state: { selectedTab: "skai-credits" } });
    }
    if (notification && notification?.module === "Timesheet") {
      navigate(`/home/staff/manage-attendance/${notification?.staff?.id}`);
    }

    if (notification && notification?.module === "ServiceRequest") {
      navigate("/home/servicerequests", {
        state: { serviceRequestId: notification?.moduleId },
      });
    }
  };

  const getUserType = Object.keys(notification?.metadata?.file || {}).includes(
    "staff"
  )
    ? "staff"
    : Object.keys(notification?.metadata?.file || {}).includes("client")
    ? "client"
    : "facility";

  const handleAcceptSignature = async () => {
    const payload = {
      signatureId: notification?.moduleId,
      staffId: notification?.staff?.id,
    };
    await updateChangeSignature(payload);
  };

  const [actionLoading, setActionLoading] = useState(false);
  const isContractorRequest = notification?.module === "contractor";

  const handleAcceptContractor = async (e) => {
    e.stopPropagation();
    setActionLoading(true);
    const success = await acceptContractorRequest(notification?._id);
    setActionLoading(false);
    if (success) {
      swal({ title: "Contractor request accepted", icon: "success" });
      handleReadNotification(notification?._id);
      getNotifications({ page: 1, limit: 10, userId: profile?.user?.id });
      getNotificationsCount();
    }
  };

  const handleDeclineContractor = async (e) => {
    e.stopPropagation();
    const confirmed = await swal({
      title: "Decline Request?",
      text: "Are you sure you want to decline this contractor request? The contractor will be removed from your account.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Decline"],
    });
    if (confirmed) {
      setActionLoading(true);
      const success = await declineContractorRequest(notification?._id);
      setActionLoading(false);
      if (success) {
        swal({ title: "Contractor request declined", icon: "success" });
        handleReadNotification(notification?._id);
        getNotifications({ page: 1, limit: 10, userId: profile?.user?.id });
        getNotificationsCount();
      }
    }
  };

  return (
    <>
      <Box
        onClick={!isContractorRequest ? handleClick : undefined}
        key={notification?._id}
        className={classes.card}
        style={isContractorRequest ? { cursor: "default" } : {}}
      >
        {isLoading?.includes(notification?._id) ? (
          <Loader color="var(--app-primary)" size={25} className={classes.loaderStyling} />
        ) : (
          <>
            <Box className={classes.titleIndicator}>
              {!notification?.readedUsers?.includes(profile?.user?.id) ? (
                <Indicator color={isReadAll ? "var(--app-text-muted)" : "var(--app-primary)"} />
              ) : (
                ""
              )}
              <Title order={3}>{notification?.title}</Title>
            </Box>
            {notification?.module === "document" ? (
              <Text size="sm" color="var(--app-text-muted)" fw={400} ff="Inter">
                {`${
                  getUserType.charAt(0).toUpperCase() + getUserType.slice(1)
                } file ${notification?.metadata?.file?.name} ${
                  moment(notification?.metadata?.file?.expiry).isAfter(moment())
                    ? "expires"
                    : "has expired"
                } on (${moment(notification?.metadata?.file?.expiry).format(
                  "MM/DD/YYYY"
                )})`}
              </Text>
            ) : (
              <Text size="sm" color={"var(--app-text-muted)"} fw={400} ff={"Inter"}>
                {notification?.message}
              </Text>
            )}

            {isContractorRequest && notification?.notificationType === "accepted" && (
              <Text size="xs" fw={600} ff="Inter" mt={8} color="var(--app-primary)">
                Accepted
              </Text>
            )}
            {isContractorRequest && notification?.notificationType === "declined" && (
              <Text size="xs" fw={600} ff="Inter" mt={8} color="var(--app-ink-red)">
                Declined
              </Text>
            )}
            {isContractorRequest && notification?.notificationType !== "accepted" && notification?.notificationType !== "declined" && (
              <Flex gap={8} mt={8}>
                <Button
                  size="xs"
                  radius="md"
                  variant="filled"
                  onClick={handleAcceptContractor}
                  loading={actionLoading}
                  styles={{ root: { fontSize: 12, height: 30, fontFamily: "Inter", backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)", "&:hover": { backgroundColor: "var(--app-primary)", opacity: 0.8 } } }}
                >
                  Accept
                </Button>
                <Button
                  size="xs"
                  radius="md"
                  color="red"
                  variant="outline"
                  onClick={handleDeclineContractor}
                  disabled={actionLoading}
                  styles={{ root: { fontSize: 12, height: 30, fontFamily: "Inter" } }}
                >
                  Decline
                </Button>
              </Flex>
            )}

            <Text size="sm" color={"var(--app-text-muted)"} fw={400} ff={"Inter"}>
              {moment(notification?.createdAt)?.fromNow()}
            </Text>
          </>
        )}
      </Box>
    </>
  );
};

export default NewNotificationCardComp;
